import React from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowRight, ArrowLeft } from "lucide-react";
import { materialDetails } from "../data/site";
import { Seo, breadcrumbLd } from "../components/Seo";
import { PageHero, CTABand } from "../components/ui-blocks";

const Block = ({ title, items }) => (
  <div>
    <h3 className="text-xl mb-4">{title}</h3>
    <ul className="space-y-2.5">
      {items.map((it) => (
        <li key={it} className="flex items-start gap-2.5 text-sm text-neutral-700">
          <Check size={16} className="text-[#CD1422] mt-0.5 shrink-0" /> {it}
        </li>
      ))}
    </ul>
  </div>
);

const MaterialDetail = () => {
  const { materialId } = useParams();
  const m = materialDetails[materialId];

  if (!m) {
    return (
      <div className="section container-custom text-center">
        <h1 className="text-4xl mb-4">Material Not Found</h1>
        <p className="text-neutral-600 mb-8">We couldn't find that material.</p>
        <Link to="/materials" className="btn btn-primary">Back to Materials</Link>
      </div>
    );
  }

  return (
    <div>
      <Seo
        title={`${m.name} Countertops`}
        description={`${m.name} — ${m.tagline} Learn about appearance, applications, characteristics and care from Premier Granite LLC.`}
        path={`/materials/${materialId}`}
        image={m.hero}
        jsonLd={breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Materials", path: "/materials" },
          { name: m.name, path: `/materials/${materialId}` },
        ])}
      />
      <PageHero eyebrow="Material" title={m.name} subtitle={m.tagline} image={m.hero} testid="material-detail-hero" />

      <section className="section bg-white">
        <div className="container-custom max-w-4xl">
          <Link to="/materials" className="inline-flex items-center gap-2 text-sm text-neutral-500 hover:text-[#CD1422] mb-8">
            <ArrowLeft size={15} /> All Materials
          </Link>
          <p className="text-lg text-neutral-700 leading-relaxed mb-4">{m.intro}</p>
          <p className="text-neutral-600 leading-relaxed mb-12"><span className="font-semibold text-neutral-800">Appearance: </span>{m.appearance}</p>

          <div className="grid md:grid-cols-3 gap-10 mb-14">
            <Block title="Common Applications" items={m.applications} />
            <Block title="Characteristics" items={m.characteristics} />
            <Block title="Maintenance" items={m.maintenance} />
          </div>

          <Link to="/contact" className="btn btn-primary">Request a Quote <ArrowRight size={17} /></Link>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default MaterialDetail;
